<!--
 * @Author: Nie Wie
 * @Date: 2020-02-23 19:19:05
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-03-30 14:59:20
 * @Description: 页脚
 -->
<template>
  <div class="footer-part" @click="to">
    <div class="footer-part__txt">
      <span>了解更多数据动态，请前往</span>
    </div>
    <div class="footer-part__lasac">
      <a href="http://www.sasclouds.com/"></a>
    </div>
    <!-- <div class="footer-part__icon"></div> -->
  </div>
</template>

<script>
export default {
  methods: {
    to() {
      window.location.href = 'http://www.sasclouds.com/'
    },
  },
}
</script>

<style lang="scss">
.footer-part {
  margin: 48px 30px;
  height: 84px;
  display: flex;
  position: relative;
  align-items:center;
  justify-content: center;
  border-radius: 42px;
  font-size:28px;
  background: #005EFF;
}
.footer-part__txt {
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color: #fff;
}
.footer-part__lasac {
  font-size: 0;
  a {
    width: 192px;
    height: 84px;
    margin: 0 10px;
    color: #FFC333;
    text-decoration: none;
    display: inline-block;
    background-image: url(../../assets/images/footer.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.footer-part__icon {
  width: 38px;
  height: 38px;
  background: url(../../assets/images/footer-right.png)
}
</style>
